export function shouldShowAttorneyPicker(
  template: { requires_attorney: boolean } | undefined
): boolean {
  return Boolean(template?.requires_attorney)
}
